export const selectSidebarMode = (state) => state.navigation.sidebarMode;
export const selectSidebarActive = (state) => state.navigation.sidebarIsOpen;
export const selectThemeMenuActive = (state) =>
    state.navigation.themeMenuIsOpen;
